import {Component, OnDestroy, OnInit} from '@angular/core';
import {MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {SelectorOficSucDialogComponent} from './selector-ofic-suc-dialog';
import {AgrisService} from '../../../../services';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-agris-selector-ofic-suc',
  templateUrl: './agris-selector-ofic-suc.component.html',
  styleUrls: ['./agris-selector-ofic-suc.component.scss', '../agris-common-styles.scss']
})
export class AgrisSelectorOficSucComponent implements OnDestroy {

  oficina = 'Oficina';
  sucursal = 'Sucursal';
  sub: Subscription[] = [];

  constructor(
    private dialog: MdDialog,
    public agrisService: AgrisService,
  ) {
    agrisService.initializeOficinaSucursal();
    this.sub.push(
      agrisService.oficina$.subscribe(x => this.oficina = x !== null ? x.Nombre : 'Oficina')
    );

    this.sub.push(
      agrisService.sucursal$.subscribe(x => this.sucursal = x !== null ? x.Nombre : 'Sucursal')
    )
  }

  ngOnDestroy() {
    this.sub.forEach(x => x.unsubscribe());
  }

  openSelectorDialog() {
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    this.dialog.open(SelectorOficSucDialogComponent, config);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-selector-ofic-suc/agris-selector-ofic-suc.component.ts